const normalizeFilterInput = (input: string): string => input.trim().toLowerCase();

export default normalizeFilterInput;
